// Params.
export const PARAMS = {
	VERBOSE: false,
	SHOW_ALERTS: false,
	SHOW_DIALOGS: false,
	SHOW_REC_DOT: false,
	IS_MANUALLY_CHECKING_HOTKEYS: false,
};